module.exports = __webpack_public_path__ + "img/us_bg_yuanjing@.f0778b01.png";